<template>
  <div class="calico-credit-box">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CalicoCreditBox',
}
</script>

<style scoped lang="scss">
.calico-credit-box {
  @include stack-space($space-medium);
  @include inset-space($space-large);
}
</style>